<template>
  <v-row>
    <template v-for="attachment in adlImages">
      <v-col cols="12" :key="attachment._id" sm="12" lg="4">
        <v-card>
          <v-img
            :src="attachment.AWSLink"
            :lazy-src="attachment.AWSLink"
            height="300"
            class="grey lighten-2"
            contain
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>

            <v-chip color="pink" label text-color="white">
              <v-icon left> mdi-label </v-icon>
              <a :href="attachment.Category" class="white--text">{{
                attachment.Category
              }}</a>
            </v-chip>
          </v-img>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  // props: {
  //   servicePlan: {
  //     type: Object,
  //     default: () => {},
  //   },
  // },
  data() {
    return {};
  },

  computed: {
    ...mapGetters("adl", ["getADLAttachments"]),

    adlImages() {
      return this.getADLAttachments?.Attachments?.map((item) => {
        let category = item.Category.replace(/^Skin Check -\s*/, "");
        return {
          AWSLink: item.AWSLink,
          Category: category
            .replace(/^[a-z]/, function (m) {
              return m.toUpperCase();
            })
            .replace(/([a-z])([A-Z])/g, "$1 $2"),
        };
      });
    },
  },
  methods: {
    downloadImage(attachment) {
      window.location.href = attachment;
    },
  },
};
</script>
